if (window.location.hash) window.scroll(0, 0)

const anchorScroll = () => {
  const hash = window.location.hash.slice(1)

  if (hash) {
    const container = document.querySelector(`[data-id="${hash}"]`)
      || document.querySelector(`#${hash}`)
    const header = document.querySelector('.c-header')
    const headerOffsetHeight = header ? header.offsetHeight : 120

    if (container) {
      const top = container.getBoundingClientRect().top + window.scrollY - headerOffsetHeight
      const left = 0
      window.scrollTo({
        top,
        left
      })
    }
  }
}

export default anchorScroll
